import { FC, useState } from 'react';
import { GenericLink, NextgenImage } from '@nextgen-web-framework/all';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import type { SocialIconProps, SocialIcon as IconProps } from './types/propsTypes';
import styles from './SocialIcon.module.scss';

const RenderIconOrSkeleton: FC<IconProps> = ({ icon }) => {
  const [imgLoading, setImgLoading] = useState(true);

  return (
    <>
      <NextgenImage
        key={`${icon.href}${icon.url}`}
        className={styles['social-image']}
        src={icon.url}
        alt={icon.alt}
        onLoad={() => setImgLoading(false)}
      />
      {imgLoading && <SkeletonLoader height={36} />}
    </>
  );
};

const SocialIcon: FC<SocialIconProps> = ({ socialIcon }) => (
  <div className={styles['social-icon-container']}>
    {socialIcon?.map((data) => (
      <GenericLink
        className={styles['social-image-container']}
        target={data.link.target}
        key={data.icon.url}
        href={data.link.url}
      >
        {RenderIconOrSkeleton({ ...data })}
      </GenericLink>
    ))}
  </div>
);

export default SocialIcon;
